<template>
    <v-row no-gutters align="end" :key="refershkey">
        <v-col cols="2">
            <QTextField v-model="count" externaledit :disabled="readonly" allowexternaloverride
                :rules="[requiredRule, floatRule]" :label="$t('servicesystem.common_objects.order.count')">
            </QTextField>
        </v-col>
        <v-col cols="auto" class="px-3">
            x
        </v-col>
        <v-col cols="3">
            <QTextField v-model="price" externaledit reverse :disabled="readonly" allowexternaloverride
                :label="$t('servicesystem.common_objects.order.price')">
            </QTextField>
        </v-col>
        <v-col cols="auto" class="px-3">
            -
        </v-col>
        <v-col cols="auto">
            <QTextField v-model="discount" externaledit reverse prefix="%" clearable placeholder="0"
                allowexternaloverride :disabled="readonly" style="width: 75px;"
                :label="$t('servicesystem.common_objects.order.discount')"
                :rules="[(v) => (parseCommaSafeDecimalField('' + v) <= 100) || 'Max 100']">
            </QTextField>
        </v-col>
        <v-col cols="auto" class="px-3">
            =
        </v-col>
        <v-col cols="0" class="text-right pt-3">
            <h4>{{ lineTotal }},-</h4>
        </v-col>
    </v-row>
</template>


<script>
import { debounce } from "debounce";

export default {
    name: "PriceControl",
    model: {
        prop: "item",
        event: "change",
    },
    props: {
        item: Object,
        ishours: Boolean,
        readonly: Boolean,
    },
    components: {},

    data() {
        return {
            refershkey: 1,
            editObject: {
                ArticleCount: 0,
                ArticlePrice: 0,
                Discount: 0,
                Duration: 0,
            },
        };
    },

    mounted() {
        this.parseItem(this.item);
    },

    methods: {
        parseItem(item) {
            //only if not identical
            if (JSON.stringify(item) === JSON.stringify(this.editObject)) {
                return;
            }
            this.editObject = Object.assign({}, item);
            this.refershkey++;
            //console.log("parseItem", item, this.editObject);
        },

        debounceEmit: debounce(function () {
            this.emit();
        }, 700),

        emit() {
            this.$emit('change', this.editObject);
        },
    },

    computed: {
        count: {
            get() {
                return this.editObject.ArticleCount;
            },
            set(value) {
                this.editObject.ArticleCount = this.parseCommaSafeDecimalField(value);
                this.debounceEmit();
            }
        },

        price: {
            get() {
                return this.editObject.ArticlePrice;
            },
            set(value) {
                this.editObject.ArticlePrice = this.parseCommaSafeDecimalField(value);
                this.debounceEmit();
            }
        },

        discount: {
            get() {
                return this.editObject.Discount;
            },
            set(value) {
                this.editObject.Discount = this.parseCommaSafeDecimalField(value);
                this.debounceEmit();
            }
        },

        lineTotal() {
            if (!this.editObject) {
                return 0;
            }
            else {
                var result = this.editObject.ArticleCount * this.editObject.ArticlePrice * (1 - (this.editObject.Discount / 100));
                //console.log("lineTotal", multiplier, price, discount, result);
                return result.toFixed(2);
            }
        },
    },

    watch: {
        item: {
            handler(newValue) {
                this.parseItem(newValue);
            },
            deep: true,
        },
    }
}
</script>


<style scoped></style>
